<template>
  <div class="kycVerifyModal-content-privacy">
    <template v-if="verifyModalData.privacyInfo.kyc_type === 'agreement_checkbox'">
      <b-form-checkbox v-model="agreementCheckbox" class="new-checkbox">
        <i18n path="scenes.ekyc.tips.agreement-checkbox-policy.v2" tag="p">
          <template #providerPrivacyPolicy>
            <a :href="url" target="_blank">{{ $t('scenes.ekyc.tips.providers-privacy-policy') }}</a>
          </template>

          <template #operatorPrivacyPolicy>
            <a :href="verifyModalData.privacyInfo.privacy_policy_url" target="_blank">
              {{ $t('scenes.ekyc.tips.operators-privacy-policy') }}
            </a>
          </template>
        </i18n>
      </b-form-checkbox>
    </template>

    <template v-else-if="verifyModalData.privacyInfo.kyc_type === 'agreement'">
      <i18n path="scenes.ekyc.tips.agreement-policy.v2" tag="p">
        <template #providerPrivacyPolicy>
          <a :href="url" target="_blank">{{ $t('scenes.ekyc.tips.providers-privacy-policy') }}</a>
        </template>

        <template #operatorPrivacyPolicy>
          <a :href="verifyModalData.privacyInfo.privacy_policy_url" target="_blank">
            {{ $t('scenes.ekyc.tips.operators-privacy-policy') }}
          </a>
        </template>
      </i18n>
    </template>

    <template v-else>
      <i18n path="scenes.ekyc.tips.no-agreement-policy.v2" tag="p">
        <template #providerPrivacyPolicy>
          <a :href="url" target="_blank">
            {{ $t('scenes.ekyc.tips.providers-privacy-policy') }}
          </a>
        </template>
      </i18n>
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'kyc-verify-modal_privacy',
    props: {
      privacyInfo: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        agreementCheckbox: false,
      }
    },
    watch: {
      agreementCheckbox(newValue, _oldValue) {
        this.UPDATE_CHECKED_VALUES(newValue)
      },
    },
    computed: {
      ...mapGetters({
        verifyModalData: 'eKyc/get_verify_modal_data',
      }),
      url() {
        switch (this.verifyModalData?.kycProvider) {
          case 'onfido':
            return this.$t('url.identity.authentication.provider-privacy-policy-onfido')
          case 'jumio':
            return this.$t('url.identity.authentication.provider-privacy-policy')
        }
      },
    },
    methods: {
      ...mapMutations({
        UPDATE_CHECKED_VALUES: 'eKyc/UPDATE_CHECKED_VALUES',
      }),
    },
  }
</script>

<style lang="scss" scoped>
  .kycVerifyModal-content-privacy {
    color: #8a8a8a;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 18px;

    p {
      margin-bottom: 0;
    }

    a {
      font-weight: 600;
    }
  }
</style>
